module.exports = __webpack_public_path__ + "static/media/rnr-image-1.6917bc7e.png";